import { render, staticRenderFns } from "./PmtaCampaignForm.vue?vue&type=template&id=004e86a9"
import script from "./PmtaCampaignForm.vue?vue&type=script&lang=js"
export * from "./PmtaCampaignForm.vue?vue&type=script&lang=js"
import style0 from "./PmtaCampaignForm.vue?vue&type=style&index=0&id=004e86a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports